export const COOKIES_MODAL_INVOKED = 'cookiesModalInvoked';
export const COOKIE_PREFERENCES_SAVED_EVENT = 'cookiePreferencesSaved';
//# sourceMappingURL=events.js.map